import React from 'react';
import Tile from './Tile';
import {TilesGridConfig} from './types';

interface TilesGridProps {
  config: TilesGridConfig;
}

const TilesGrid: React.FC<TilesGridProps> = ({config}) => {
  return (
    <section className="bg-gray-100 py-8">
      <div className="container mx-auto px-4">
        <div className="hidden grid
          grid-cols-1 grid-cols-2 grid-cols-4 grid-cols-6 grid-cols-8
          md:grid-cols-1 md:grid-cols-2 md:grid-cols-4 md:grid-cols-6 md:grid-cols-8
          lg:grid-cols-1 lg:grid-cols-2 lg:grid-cols-4 lg:grid-cols-6 lg:grid-cols-8
          xl:grid-cols-1 xl:grid-cols-2 xl:grid-cols-4 xl:grid-cols-6 xl:grid-cols-8
          col-span-1 col-span-2 col-span-4 col-span-6 col-span-8
          row-span-1 row-span-2 row-span-4 row-span-6 row-span-8
        "/>
        <div className="gap-6 grid grid-cols-4 auto-rows-fr">
          {config.tiles.map((tile, index) => (
            <Tile key={index} tile={tile}/>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TilesGrid;

